import api from "./api";

export const civicServicesService = {
  list: async (active) => {
    const response = await api.get("/civic-services/list", {
      params: active === 0 || active === 1 ? { active } : undefined,
    });
    // Backend returns array directly
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/civic-services/${id}`);
    return response.data;
  },

  create: async (payload) => {
    const response = await api.post("/civic-services/create", payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await api.put(`/civic-services/${id}`, payload);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`/civic-services/${id}`);
    return response.data;
  },

  uploadIcon: async (formData) => {
    const response = await api.post("/civic-services/upload-icon", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
};

